// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YJ-z","twoColumnImage":"ZJ-z"};